import { teamUserReports } from './types';

export * from './reportEntities/actions';

export const requestTeamUserReports = (teamIds) => ({
  type: teamUserReports.request,
  teamIds,
});
export const requestTeamUserReportsSuccess = (teamIds, response) => ({
  type: teamUserReports.success,
  teamIds,
  response,
});
export const requestTeamUserReportsFailure = (teamIds, error) => ({
  type: teamUserReports.failure,
  teamIds,
  error,
});
